import React from "react";
import { basename } from "../../../config";

function Error() {
  return (
    <div className="noPageFound">
      <img src={`/${basename}/Assets/Images/mtslogo.svg`} alt="mtsLogo" />
      <p>No page found!</p>
    </div>
  );
}

export default Error;
